import * as types from './types';

export const getApplicationList = (queryParams) => ({
    type: types.CANDIDATE_APPLICATIONS_GET_LIST,
    queryParams
});

export const setApplicationList = (applications) => ({
    type: types.CANDIDATE_APPLICATIONS_SET_LIST,
    applications
});

export const resetApplicationList = () => ({
  type: types.CANDIDATE_APPLICATIONS_RESET_LIST
});

export const setApplicationsListLoading  = (isLoading = false) => ({
    type: types.CANDIDATE_APPLICATIONS_SET_LIST_LOADING,
    isLoading
});

export const getApplicationsSchools = () => ({
    type: types.CANDIDATE_APPLICATIONS_GET_SCHOOLS
});

export const setApplicationsSchools = (schools) => ({
    type: types.CANDIDATE_APPLICATIONS_SET_SCHOOLS,
    schools
});

export const getApplicationsCountries = () => ({
    type: types.CANDIDATE_APPLICATIONS_GET_COUNTRIES
});

export const setApplicationsCountries = (countries) => ({
    type: types.CANDIDATE_APPLICATIONS_SET_COUNTRIES,
    countries
});

export const getApplicationsStatusStats = (queryParams) => ({
    type: types.CANDIDATE_APPLICATIONS_GET_STATUS_STATS,
    queryParams
});

export const setApplicationsStatusStats = (stats) => ({
    type: types.CANDIDATE_APPLICATIONS_SET_STATUS_STATS,
    stats
});

export const setApplicationsQueryParams = (queryParams) => ({
  type: types.CANDIDATE_APPLICATIONS_SET_QUERY_PARAMS,
  queryParams
});


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-applications/index.js